import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { RequireLoggedOut } from "@/app/router";
import { FunnelLayout } from "../components";
import {
  Contact,
  Disqualified,
  FunnelIntake,
  Measurements,
  MedicalReview,
  Payment,
  PersonalInfo,
  Pricing,
} from "../screens";
import { FUNNEL_ROUTE } from "./constants";

export const getFunnelRoute = (): RouteObject => ({
  path: FUNNEL_ROUTE.BASE,
  element: (
    <RequireLoggedOut>
      <FunnelLayout />
    </RequireLoggedOut>
  ),
  children: [
    { path: FUNNEL_ROUTE.MEASUREMENTS, element: <Measurements /> },
    { path: FUNNEL_ROUTE.PERSONAL_INFO, element: <PersonalInfo /> },
    { path: FUNNEL_ROUTE.MEDICAL_REVIEW, element: <MedicalReview /> },
    { path: FUNNEL_ROUTE.CONTACT, element: <Contact /> },
    { path: FUNNEL_ROUTE.PRICING, element: <Pricing /> },
    { path: FUNNEL_ROUTE.PAYMENT, element: <Payment /> },
    { path: FUNNEL_ROUTE.DISQUALIFIED, element: <Disqualified /> },
    { path: `${FUNNEL_ROUTE.DISQUALIFIED}/:slug`, element: <Disqualified /> },
    { path: `${FUNNEL_ROUTE.INTAKE}/:slug`, element: <FunnelIntake /> },
    {
      index: true,
      element: <Navigate replace to={FUNNEL_ROUTE.MEASUREMENTS} />,
    },
    {
      path: "*",
      element: <Navigate replace to={FUNNEL_ROUTE.MEASUREMENTS} />,
    },
  ],
});
